import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import { CommonService } from 'src/@services/common.service';
import { FormService } from 'src/@services/form.service';
import { paybevEnvironment } from 'src/environments/environment';
import { CommonPagesService } from '../../common-pages.service';
import { ResponseStatus, TransactionsType } from '../../enum';

@Component({
  selector: 'app-email-transaction-modal',
  templateUrl: './email-transaction-modal.component.html',
  styleUrls: ['./email-transaction-modal.component.scss'],

  standalone: false,
})
export class EmailTransactionModalComponent {
  isVisible = true;
  @Input() selectedData: any;
  @Input() transactionType: any;
  @Input() PayBevLink: any;
  @Output() hideEmailTransactionModal = new EventEmitter();
  emailDetails: any;
  TransactionsType = TransactionsType;
  isLoadingData: boolean = true;
  isSendingEmail: boolean = false;
  editorConfig: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: 'auto',
    minHeight: '18rem',
    maxHeight: '25rem',
    width: 'auto',
    minWidth: '0',
    translate: 'yes',
    enableToolbar: true,
    showToolbar: false,
    placeholder: 'Enter body here...',
    defaultParagraphSeparator: '',
    defaultFontName: '',
    defaultFontSize: '',
    fonts: [
      { class: 'arial', name: 'Arial' },
      { class: 'times-new-roman', name: 'Times New Roman' },
      { class: 'calibri', name: 'Calibri' },
      { class: 'comic-sans-ms', name: 'Comic Sans MS' },
    ],
    customClasses: [
      {
        name: 'quote',
        class: 'quote',
      },
      {
        name: 'redText',
        class: 'redText',
      },
      {
        name: 'titleText',
        class: 'titleText',
        tag: 'h1',
      },
    ],
    uploadUrl: 'https://api.exapple.com/v1/image/upload',
    uploadWithCredentials: false,
    sanitize: true,
    toolbarPosition: 'top',
    toolbarHiddenButtons: [],
    upload: this.uploadImageByAngularEditor,
  };
  currentUploadedImageSize: string;

  constructor(
    private _cS: CommonService,
    private _cpS: CommonPagesService,
    public _fS: FormService
  ) {
    _fS.emailForm_fb();
  }

  ngOnInit() {
    if (this.transactionType == TransactionsType.Investment) {
      this.getEmailInvestmentDetails();
    } else if (this.transactionType == TransactionsType.Payment) {
      this.getEmailPaymentDetails();
    } else {
      this.getEmailExpenseDetails();
    }
  }

  uploadImageByAngularEditor(file: File): any {
    var url, img: any;
    let reader = new FileReader();

    img = new Image();
    img.onload = () => {
      var size = img.height + ' X ' + img.width;
      try {
        var ButtonElement = document.getElementById(
          'UpdateUploadedImageSizeButton'
        );
        ButtonElement?.setAttribute('currentUploadedImageSize', size);
        ButtonElement?.click();
      } catch (ex) { }
    };
    img.src = URL.createObjectURL(file);
    reader.onload = () => {
      url = reader.result;
      document.execCommand('insertHTML', false, `<img src='${url}'>`);
    };
    reader.abort();
    if (file) {
      reader.readAsDataURL(file);
    }
  }
  // Function to fix base64 padding
  fixBase64Padding(base64: string): string {
    let paddingNeeded = 4 - (base64.length % 4);
    if (paddingNeeded === 3) paddingNeeded = 1;
    if (paddingNeeded !== 4) {
      base64 += '='.repeat(paddingNeeded);
    }
    return base64;
  }
  getEmailInvestmentDetails() {
    // API call to get email investment
    this._cpS
      .getEmailInvestmentDetails(
        this.selectedData.id,
        encodeURIComponent(this.PayBevLink)
      )
      .subscribe((response: any) => {
        if (response.responseStatus == ResponseStatus.success) {
          // const cleanedBase64String = response.result.htmlTemplate.replace(
          //   /\s/g,
          //   ''
          // ); // Remove any whitespace
          // const fixedBase64String = this.fixBase64Padding(cleanedBase64String); // Fix padding
          // const decodedHtml = atob(fixedBase64String); // Decode base64 to plain HTML string

          // const base64String = 'YOUR_BASE64_STRING_HERE';
          // const decodedHtml = atob(base64String); // Decodes base64 to plain HTML string
          this.emailDetails = response.result;
          this._fS.emailForm.patchValue({
            subject: response.result.subject,
            to: response.result.toEmail,
            body: `<h1>Investment Issue</h1><br><div>Your assistance is needed with the request below.</div>`,
            cc: 'ar@paybev.us'
          });
          this._fS.emailForm.get('from')?.disable();
        }
        this.isLoadingData = false;
      });
  }
  getEmailPaymentDetails() {
    // API call to get email investment

    this._cpS
      .getEmailPaymentDetails(
        this.selectedData.id,
        encodeURIComponent(this.PayBevLink)
      )
      .subscribe((response: any) => {
        if (response.responseStatus == ResponseStatus.success) {
          // const base64String = 'YOUR_BASE64_STRING_HERE';
          // const decodedHtml = atob(base64String); // Decodes base64 to plain HTML string
          this.emailDetails = response.result;
          this._fS.emailForm.patchValue({
            subject: response.result.subject,
            to: response.result.toEmail,
            body: `<h1>Expense Issue</h1><br><div>Your assistance is needed with the request below.</div>`,
            cc: 'ap@paybev.us'
          });
          this._fS.emailForm.get('from')?.disable();
        }
        this.isLoadingData = false;
      });
  }
  getEmailExpenseDetails() {
    // API call to get email investment
    this._cpS
      .getEmailExpenseDetails(
        this.selectedData.id,
        encodeURIComponent(this.PayBevLink)
      )
      .subscribe((response: any) => {
        if (response.responseStatus == ResponseStatus.success) {
          // const base64String = 'YOUR_BASE64_STRING_HERE';
          // const decodedHtml = atob(base64String); // Decodes base64 to plain HTML string
          this.emailDetails = response.result;
          this._fS.emailForm.patchValue({
            subject: response.result.subject,
            to: response.result.toEmail,
            body: `<h1>Expense Issue</h1><br><div>Your assistance is needed with the request below.</div>`,
            cc: 'ap@paybev.us'
          });
          this._fS.emailForm.get('from')?.disable();
        }
        this.isLoadingData = false;
      });
  }

  showModal(): void {
    this.isVisible = true;
  }

  handleCancel(): void {
    this.isVisible = false;
    this.hideEmailTransactionModal.emit(this.isVisible);
  }
  checkImageUploaded() {
    var descValue = this._fS.emailForm.get('body')?.value;
    if (!descValue.match(/<img/)) {
      this.currentUploadedImageSize = '';
    }
  }
  convertHtmlToBase64(htmlContent: string): string {
    try {
      // Encode the HTML content into Base64
      const base64String = btoa(htmlContent);
      return base64String;
    } catch (error) {
      console.error('Error encoding HTML to Base64: ', error);
      return '';
    }
  }

  convertToLoginUrl(url: string): string {
    const urlObj = new URL(url);

    // Extract search parameters
    const t = urlObj.searchParams.get('t');
    const e = urlObj.searchParams.get('e');
    const tid = urlObj.searchParams.get('tid');
    const type = urlObj.searchParams.get('type');
    const stype = urlObj.searchParams.get('stype');

    // Extract siteId from the path
    const pathParts = urlObj.pathname.split('/');
    const siteId = pathParts[2];

    // Construct the new URL
    if (stype) {
      return `${paybevEnvironment.URL}login?siteId=${siteId}&t=${t}&e=${e}&tid=${tid}&type=${type}&stype=${stype}`;
    } else {
      return `${paybevEnvironment.URL}login?siteId=${siteId}&t=${t}&e=${e}&tid=${tid}&type=${type}`;
    }
  }
  handleOk() {
    if (this._fS.emailForm.valid) {
      this.isSendingEmail = true;
      const formValue = this._fS.emailForm.value;
      const htmlContent = this._fS.emailForm.get('body')?.value; // Assuming 'body' is the formControlName

      const base64EncodedHtml = this.convertHtmlToBase64(htmlContent);

      var requestBody = {
        // htmlTemplate: base64EncodedHtml,
        subject: formValue.subject,
        FromEmail:
          this.transactionType == TransactionsType.Investment
            ? 'ar@paybev.us'
            : 'ap@paybev.us',
        toEmail: formValue.to,
        ccEmail: formValue.cc.trim(),
        submittedDate: this.emailDetails.submittedDate,
        user: this.emailDetails.user,
        site: this.emailDetails.site,
        supplier: this.emailDetails?.supplier,
        vendor: this.emailDetails?.vendor,
        rep: this.emailDetails?.rep,
        repEmail:
          this.transactionType == TransactionsType.Investment
            ? this.emailDetails.repEmail
            : this.emailDetails.vendorEmail,
        availableBalanceValue: this.emailDetails.availableBalanceValue,
        currentBalanceValue: this.emailDetails.currentBalanceValue,
        outstandingBalanceValue: this.emailDetails.outstandingBalanceValue,
        // invoiceLinkValue: this.convertToLoginUrl(this.PayBevLink),
        // ExpenseLinkValue: this.convertToLoginUrl(this.PayBevLink),
        isIncludeBalances: this._fS.emailForm.get('includeInMail')?.value,
        customText: base64EncodedHtml,
      };
      if (this.transactionType == TransactionsType.Investment) {
        requestBody['invoiceLinkValue'] = this.convertToLoginUrl(this.PayBevLink);
        this.sendInvestmentEmail(requestBody);
      } else {
        requestBody['ExpenseLinkValue'] = this.convertToLoginUrl(this.PayBevLink);
        this.sendPaymentEmail(requestBody);
      }
    } else {
      this._cS.markFormGroupTouched(this._fS.emailForm);
    }
  }
  sendInvestmentEmail(requestBody: any) {
    this._cpS
      .SendInvestmentIssueEmail(requestBody)
      .subscribe((response: any) => {
        if (response.responseStatus == ResponseStatus.success) {
          this.handleCancel();
          this._cS.displayMessage('success', response.message);
        } else {
          this._cS.displayMessage('error', response.message);
        }
        this.isSendingEmail = false;
      });
  }
  sendPaymentEmail(requestBody: any) {
    this._cpS
      .SendPaymentExpenseIssueEmail(requestBody)
      .subscribe((response: any) => {
        if (response.responseStatus == ResponseStatus.success) {
          this.handleCancel();
          this._cS.displayMessage('success', response.message);
        } else {
          this._cS.displayMessage('error', response.message);
        }
        this.isSendingEmail = false;
      });
  }

  onSubmit(): void {
    if (this._fS.emailForm.valid) {
      // Send email logic here
      this.isVisible = false;
    }
  }
}
